import React from 'react';
import { connect } from 'react-redux';
import * as Constants from '../../Common/constants';
import * as Utils from '../../Common/utils';
import PlayerItem from './PlayerItem.js';
import { readLeaderboardAction } from '../../Actions/LeaderboardActions';
import MediaQuery from 'react-responsive'

import { makeStyles } from '@material-ui/core/styles';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';
import Banner from '../../images/banner.jpg';
import HoleStrokeIndicator from './HoleStrokeIndicator.js';
import Countdown from 'react-countdown';
import ScoreTable from './ScoreTable';

const useStyles = makeStyles({
    root: {
        width: '100%',
        overflowX: 'auto',
    },
    table: {
        minWidth: 650,
        backgroundColor: 'blue',
        color: 'yellow'
    },
    header: {
        backgroundColor: 'green',
        color: 'red'
    }
});


export class LeaderboardPage extends React.Component {



    constructor(props) {
        super(props);

        this.state = { serverErrors: {} };


        console.info('LeaderboardPage - constructor called.');
    }

    componentWillMount() {
        console.info('LeaderboardPage - componentWillMount called.');
    }

    componentDidMount() {
        console.info('LeaderboardPage - componentDidMount called.');
        var start = this.props.location.search.indexOf("id=");
        var end = this.props.location.search.indexOf("&", start);

        var id = null;

        if (start > 0 && end > 0) {

            id = this.props.location.search.slice(start + 3, end);

        } else if (start > 0) {

            id = this.props.location.search.slice(start + 3);

        } else {
            id = Constants.LEADERBOARD_ID;
        }
        this._leaderboardid = id;
        this.loadLeaderboard(id);
        //set timeout
        console.log("ID ", id);
        this._timer = setInterval(() => {
            this.loadLeaderboard(id);
    }, 6000);

    }



    shouldComponentUpdate() {
        return true;
    }

    componentWillUpdate() {
    }

    componentDidUpdate() {
    }

    componentWillUnmount() {
        clearTimeout(this._timer);
    }




    render() {
        let leaderboard = this.state.leaderboard;
        console.log("LEADAERBOARD ", leaderboard)
        if (!leaderboard) {
            return this.renderEmptyLeaderboard();
        }
        return this.renderLeaderboard(leaderboard);

    }


    renderLeaderboard(leaderboard) {
        var classes = useStyles;

        let players = Utils.getPlayers(leaderboard);
        setPlayersEvents(players, this.props.leaderboard);
        players.sort(function (a, b) {

            return a.total - b.total;

        });

        let currentRound = 0;
        let backArrow = Constants.IMAGE_SERVER + "/images/back_arrow.png";
        if(leaderboard.groups && leaderboard.groups.length > 0){
            currentRound = leaderboard.groups[leaderboard.groups.length-1].round;

        }
        var i = 1;
        var prevTotal;

        const min = 1;
        const max = 10000;
        const rand = min + Math.random() * (max - min);
        return (

            <Paper>
                {this.renderHeader(leaderboard)}{this.props.scoutevents && this.props.scoutevents.length}
                <div className="navmenu" style={{position:'sticky', top:0, zIndex:100}}>
                    <img className="backArrow" src={backArrow} onClick={() => this.props.history.goBack()}></img>
                    {currentRound > 0 ? <span style={styles.round}>ROUND {currentRound}</span> : null}
                    <p>{leaderboard.location}</p>
                    <div className="navmenubar">
                        <h6 style={{ paddingLeft: "13px", color: "white" }}>PLAYERS</h6><div className="confirmedExplained" ><span className="confirmedCrowd" style={{ marginRight: "2px" }}></span> = Crowd confirmed </div></div>
                </div>
                <Table className={classes.table} style={{ width: "auto", tableLayout: "auto" }}stickyHeader >
                    <colgroup>
                        <col style={{ width: '2%'}}/>
                        <col style={{ width: '5%'}}/>
                        <col style={{ width: '20%'}}/>
                        <col style={{ width: '9%'}}/>
                        <col style={{ width: '8%'}}/>
                        <col style={{ width: '8%'}}/>
                        <col style={{ width: '50%'}}/>
                    </colgroup>
                    <TableHead style={{ height:10}} >
                        <TableRow style={{fontWeight:600, position:'sticky', top:'84px', zIndex:100}}>
                            <MediaQuery minWidth={300} >
                                <TableCell style={{ fontSize:'0.4em'}}>Pos</TableCell>
                                <TableCell ></TableCell>
                                <TableCell style={{ fontSize:'0.4em'}} >Name</TableCell>
                                <TableCell style={{ fontSize:'0.4em'}}>Today</TableCell>
                                <TableCell style={{ fontSize:'0.4em'}}>Score</TableCell>
                                <TableCell style={{ fontSize:'0.4em'}}>Hole</TableCell>
                                <TableCell style={{ fontSize:'0.4em', borderLeft:'1px solid #c2bcbc'}} align='center'>Scout</TableCell>
                            </MediaQuery>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {players.map(player => {
                            if (player.total != prevTotal) {   // remove player position if they are equal.
                                player.pos = i;
                            }
                            i++;
                            prevTotal = player.total;

                           return <TableRow key={player.name + rand} onClick={() => this.onClickPlayer(player, leaderboard)} >
                                <MediaQuery minWidth={300} >
                                    <TableCell component="th" scope="row" style={{width:5, color: 'gray'}}><div style={{fontSize:8}}>{player.pos}</div></TableCell>
                                    <TableCell component="th" scope="row"><div style={{ flexDirection: "row" }}><span style={{ marginBottom: 5 }}>{this.getCountyFlag(player.country)}</span></div></TableCell>
                                    <TableCell className="leaderboardName" align="left"><span style={{
                                        paddingBottom: '10px', fontFamily: 'titling-gothic-fb, sans-serif',
                                        fontWeight: '100', fontStyle: 'normal', fontSize: '0.75em', textAlign:'left !important'
                                    }}>{player.name.split(" ")[0].charAt(0).toUpperCase() + player.name.split(" ")[0].slice(1)}</span><br></br><span className="leaderboardName" style={{ fontFamily: 'titling-gothic-fb, sans-serif', fontWeight: '700', fontStyle: 'normal', fontSize: '0.75em' }}>{player.name.split(" ")[1].charAt(0).toUpperCase() + player.name.split(" ")[1].slice(1)}</span></TableCell>
                                    <TableCell style={{ fontSize: (player.currentHolesPlayed === 0 && player.currentStroke === 0) || player.todayScore == 0  ? '0.4em' : '0.6em', fontFamily: 'titling-gothic-fb, sans-serif',fontWeight: '100'}} align='center'>{player.currentHolesPlayed === 0 && player.currentStroke === 0 ? player.startTime : player.todayScore == 0 ? "PAR" : player.todayScore > 0  ? '+' + player.todayScore : player.todayScore}{getConfirmed(this.props.confirmed, leaderboard, player)}</TableCell>
                                    <TableCell style={{ fontSize:'0.6em', fontFamily: 'titling-gothic-fb, sans-serif',fontWeight: '100'}} align='center'>{player.total == 0 ? "PAR" : player.total > 0 ? '+' + player.total : player.total}</TableCell>
                                    <TableCell style={{ fontSize:'0.6em', fontFamily: 'titling-gothic-fb, sans-serif',fontWeight: '100'}} align='center'>{player.currentHole > 0 ? player.currentHole : ""}</TableCell>
                                    <TableCell style={{ fontSize:'0.6em', borderLeft:'1px solid #c2bcbc'}} align='center'>{getScoutInfo(player, leaderboard)}</TableCell>
                                </MediaQuery>
                            </TableRow>
                            })}

                    </TableBody>

                </Table>
                {players.length === 0 && <div className="emptyTable">Leaderboard is coming soon, stay tuned</div>}
            </Paper>


        );

    }

    renderEmptyLeaderboard() {
        document.getElementsByClassName("emptyTable").innerHTML = "test";
        /*empty.textContent("Leaderboard will show when ready");*/
        return (<div style={emptyStyle}>Loading leaderboard...</div>);
    }
    renderHeader(leaderboard) {
        let backArrow = Constants.IMAGE_SERVER + "/images/back_arrow.png";
        let Banner = Constants.IMAGE_SERVER + "/images/leaderboard-wallpaper.jpg";
        return (<div style={{ backgroundColor: 'white', color: 'white' }}>
            <div className="imageContainer">
                <img className="tournamentBanner" style={{ width: '100%', marginTop: '0px' }} src={Banner} />
                <div className="imageText">{leaderboard.name}</div>
            </div>
            {/*<img className="leaderboardBanner" style={{ width: '100%', marginTop: '0px' }} src={Banner} />*/}
            {/*<div className="navmenu">
                <img className="backArrow" src={backArrow} onClick={() => this.props.history.goBack()}></img>
                <p>{leaderboard.location}</p>
                <div className="navmenubar">
                    <h6 style={{ paddingLeft: "13px", color: "white" }}>PLAYERS</h6><div className="confirmedExplained" ><span className="confirmedCrowd" style={{ marginRight: "2px" }}></span> = Crowd confirmed </div></div>
            </div>*/}
        </div>);
    }

    getCountyFlag(countryCode) {
        let image = Constants.IMAGE_SERVER + "/images/flags/flag_" + countryCode + ".jpg"
        if (!countryCode) {
            image = Constants.IMAGE_SERVER + "/images/golf_ball.jpg"
            return <img style={{ borderRadius: '50%', width: '20px' }} src={image} />
        }
        return <img style={{ borderRadius: '50%', width: '20px', paddingRight: 0 }} src={image} />
        //return <img style={{borderRadius:'50%', width:'20px', paddingRight:10}} src={Constants.IMAGE_SERVER + "/images/flags/flag_"+player.country +".jpg"} />

    }

    loadLeaderboard(id) {

        var url = Constants.SERVER + "/leaderboard/" + id;
        var component = this;
        fetch(url)
            .then(function (response) {
                return response.json();
            })
            .then(function (json) {
                //console.log("response:", json);
                component.setState({
                    leaderboard: json
                })

            });
    }


    onClickPlayer(player, leaderboard) {
        console.log("onClickPlayer", player);

        if (hasScout(player)) {
            this.props.history.push("/playergroup?id=" + player.groupid + "&tid=" + this._leaderboardid + "&playerid=" + player.id);

        }

    }

}
const mapStateToProps = state => ({
    leaderboard: state.leaderboard,
    confirmed: state.leaderboard.confirmed

});

/**
* Import action from dir action above - but must be passed to connect method in order to trigger reducer in store
* @type {{UserUpdate: UserUpdateAction}}
*/
const mapActionsToProps = {
    readLeaderboardAction
};
export default connect(mapStateToProps, mapActionsToProps)(LeaderboardPage);


const emptyStyle = {

    'textAlign': 'center',
    'margin': '0 auto'
};

const styles = {
    leaderboardheader: {
        'borderRightWidth': 'thin',
        'borderRightColor': 'rgb(241, 241, 241)',
        'borderRightStyle': 'solid',
        'height': '10px'
    },
    round: {
        'color':' rgb(138, 119, 73)',
        'position': 'absolute',
        'right': 0,
        'padding': '10px',
    },
    TableRow:{
        'gridTemplateColumns' : 'minmax(50px, 100px) 3fr,2fr,2fr,3fr',
    },
    leaderboardheaderTest: {
        'backgroundColor': 'black'
    },
    leaderboardName: {

        'textAlign': 'left',
        'fontWeight': '400',
        'marginLeft': '20px',
        'marginRight': '20px',
        'position': 'absolute',
        'bottom': '0',
        'marginBottom': '40px'
    },
    leaderboardheaderName: {

        'marginBottom': '3px',
        'fontWeight': '900',
        'lineHeight': '10px',
        'textAlign': 'center',
        'fontSize': '0.6em',
        'backgroundColor': 'gray'
    },
    leaderboardheaderNameLeft: {

        'marginBottom': '3px',
        'fontWeight': '900',
        'lineHeight': '10px',
        'textAlign': 'left',
        'fontSize': '0.6em',
        'backgroundColor': 'gray'

    },
    leaderboardheaderPos: {
        'width': '5%',
        'borderRight': '#e3e2e2',
        'marginBottom': '3px',
        'fontWeight': '900',
        'lineHeight': '10px',
        'textAlign': 'left',
        'fontSize': '0.6em',

    },
    leaderboardheaderScore: {
        'width': '10%',
        'borderRightWidth': 'thin',
        'borderRightColor': 'rgb(241, 241, 241)',
        'borderRightStyle': 'solid',
        'textAlign': 'center',
        'fontWeight': '400',
        'fontFamily': 'titling-gothic-fb-skyline, sans-serif',
        'fontSize': '1.2em'
    },
    leaderboardheaderHole: {
        'width': '10%',
        'borderRightWidth': 'thin',
        'borderRightColor': 'rgb(241, 241, 241)',
        'borderRightStyle': 'solid',
        'textAlign': 'center',
        'fontWeight': '400',
        'fontFamily': 'titling-gothic-fb-skyline, sans-serif',
        'fontSize': '1.2em'
    },
    scountInformation:{
        'display': 'flex',
    'flexDirection': 'column',
    'alignItems': 'flexStart',
    /* width: 200px; */
    'alignItems': 'center',
    }
}


function getConfirmed(conf, leaderboard, player) {
    if (!player.latestPlayerEvent) {
        return "";
    }
    if (player.latestPlayerEvent && player.latestPlayerEvent.type == "RESULT" && player.confirmationLevel == "CROWD") {
        return <div className="confirmedCrowd"></div>

    } else {

        let confirmed = conf !== undefined ? conf.confirmed : [];
        if (confirmed !== undefined) {

            for (var i = 0; i < confirmed.length; i++) {
                if (confirmed[i] && player.latestPlayerEvent && player.latestPlayerEvent.type == "RESULT") {

                    if (confirmed[i] && confirmed[i].playerId == player.id && confirmed[i].confirmationLevel == "CROWD" && player.currentHole == confirmed[i].holeIndex) {
                        return <div className="confirmedCrowd"></div>
                    }
                }
            }
        } else if (player.latestPlayerEvent && player.latestPlayerEvent.type == "RESULT" && player.confirmationLevel == "CROWD")
            return <div className="confirmedCrowd"></div>
        else
            return null
    }
}
function getScoutInfo(player, leaderboard) {
    //console.log("getScoutInfo", player.latestPlayerEvent);
    let playerFinished = false;
    if (!player.latestPlayerEvent) {
        return "";
    }
    var data = player.latestPlayerEvent.data;
    var json = JSON.parse(data);

    if (player.latestPlayerEvent.scoutId != "999") {
        var scouttext = "";
        var par = getHolePar(player.latestPlayerEvent, leaderboard);
        var laststroke = 0;
        //var styleString = "tournamentcoverage";
        var styleString = "leaderboardEventBox";
        var strokecolor = "white";
        if (player.latestPlayerEvent && player.latestPlayerEvent.type == "PREPARE_HIT") {
            scouttext = "preparing to hit";
            laststroke = player.latestPlayerEvent.strokeIndex;
            styleString += " none";
            strokecolor = "#fac800";
        } else if (player.latestPlayerEvent && player.latestPlayerEvent.type == "RESULT" && player.currentHole > 0) {
            var data = player.latestPlayerEvent.data;
            var json = JSON.parse(data);
            scouttext = getResultAsString(json.result);
            laststroke = player.latestPlayerEvent.strokeIndex;
            strokecolor = "black";
           // strokecolor = getResultAsColor(json.result);
            playerFinished = true;
        } else if (player.latestPlayerEvent && player.latestPlayerEvent.type == "STROKE") {

            var data = player.latestPlayerEvent.data;
            var json = JSON.parse(data);
            laststroke = player.latestPlayerEvent.strokeIndex;
            scouttext = json.lie;
            strokecolor = "black";
        } else if (player.latestPlayerEvent && player.latestPlayerEvent.type == "HIT") {
            styleString += " waiting blink_me2";
            var data = player.latestPlayerEvent.data;
            var json = JSON.parse(data);
            laststroke = player.latestPlayerEvent.strokeIndex;
            scouttext = json.lie;
            strokecolor = "black";
        } else {
            return "";
        }

        if (scouttext != null) {
            if (scouttext.toLowerCase().includes("semi")) {
                styleString += " semi-ruff";
            } else if (scouttext === "Ruff") {
                styleString += " ruff";
            } else if (scouttext.toLowerCase().includes("prepare")) {
                styleString += " prepare";
            } else if (scouttext.toLowerCase().includes("sand")) {
                styleString += " sand";
            } else if (scouttext.toLowerCase().includes("water")) {
                styleString += " water";
            } else if (scouttext.toLowerCase().includes("green")) {
                styleString += " green";
            } else if (scouttext.toLowerCase().includes("fairway")) {
                styleString += " fairway";
            } else if (scouttext.toLowerCase().includes("obstacle")) {
                styleString += " Obstacle";
            }
            else { styleString += " unknown"; }
        }
        return (
            <div>
                <span className={styleString}><p>{scouttext}</p></span>

                <HoleStrokeIndicator par={par} stroke={laststroke} strokecolor={strokecolor} stylestring={styleString} result={json.result} playerFinished={playerFinished} />

            </div>
        );
    }

    // if (player.latestPlayerEvent && player.latestPlayerEvent.type == "RESULT" && player.currentHole > 0) {

    //   var data = player.latestPlayerEvent.data;
    //   var json = JSON.parse(data);
    //   var info = getResultAsString(json.result);
    //   return (<span className="tournamentcoverage">{info}</span>);

    // } else if (player.latestPlayerEvent && player.latestPlayerEvent.type == "PREPARE_HIT") {
    //   let holepar = getHolePar(player.latestPlayerEvent, leaderboard);

    //   return (<div><span>{player.latestPlayerEvent.strokeIndex}/{holepar}</span><span className="tournamentcoverage blink_me">preparing to hit</span></div>);

    // } else if (player.latestPlayerEvent && player.latestPlayerEvent.type == "STROKE") {

    //   var data = player.latestPlayerEvent.data;
    //   var json = JSON.parse(data);
    //   var info = json.lie;
    //   return (<span className="tournamentcoverage">{info}</span>);

    // }
    // else if (player.groupid == 6876) {

    //   return (<span className="tournamentcoverage">scout</span>);

    // } else {

    //   return "";

    // }

}

function hasScout(player) {
    if (player && player.latestPlayerEvent) {
        return true;
    } else if (player.groupid == 6501) {
        return true;
    }

    return false;
}

function getResultAsString(result) {
    if (result == 0) {
        return "Par";
    } else if (result == -1) {
        return "Birdie";
    } else if (result == -2) {
        return "Eagle";
    } else if (result == 1) {
        return "Bogey";
    } else if (result == 2) {
        return "D. bogey";
    } else if (result > 2) {
        return "other";
    } else {
        return result.toString();
    }

}

function getResultAsColor(result) {
    if (result == 0) {
        return "black";
    } else if (result == -1) {
        return "red";
    } else if (result == -2) {
        return "yellow";
    } else if (result == 1) {
        return "blue";
    } else if (result == 2) {
        return "gray";
    } else if (result > 2) {
        return "gray";
    } else {
        return 'black';
    }

}

function setPlayersEvents(players, leaderboard) {
    if (!players || !leaderboard || !leaderboard.leaderboard || !leaderboard.leaderboard.events) {
        return;
    }

    let scoutevents = leaderboard.leaderboard.events;


    let playerEventsMap = Utils.getPlayerEventsMap(scoutevents);

    players.forEach(p => {

        let playerevents = playerEventsMap[p.id];

        updateLatestPlayerEvent(p, playerevents);

    });

}

function updateLatestPlayerEvent(player, events) {
    if (!events) {
        return;
    }
    console

    let newlatestevent = events[events.length - 1];
    let oldLatestEvent = player.latestPlayerEvent;

    if (newlatestevent && !oldLatestEvent || oldLatestEvent.id < newlatestevent.id) {

        console.log("PlayerEvent replace ", oldLatestEvent, newlatestevent);
        player.latestPlayerEvent = newlatestevent;

        if (newlatestevent.total !== null && newlatestevent.total !== undefined) {
            player.total = newlatestevent.total;
        }
        if (newlatestevent.currentHole !== undefined) {
            player.currentHole = newlatestevent.currentHole;
        }
        if (newlatestevent.holeIndex !== undefined) {
            player.currentHole = newlatestevent.holeIndex;
        }
    }
}

function getHolePar(event, leaderboard) {
    if (!event) {
        return 0;
    }
    var hole = null;

    if (event.currentHole) {
        hole = event.currentHole;
    } else if (event.holeIndex && event.holeIndex > 0) {
        hole = event.holeIndex;
    }

    if (!hole) {
        //console.log("no currentHole in event object");
        return 0;
    }

    if (!leaderboard.courses || !leaderboard.courses[0]) {
        console.log("no courses in leaderboard object");
        return 0;
    }



    let course = leaderboard.courses[0];

    if (!course.holes) {
        console.log("no holes in course object");
        return 0;
    }
    let holeObject = course.holes[hole - 1];

    return holeObject ? holeObject.par : 0;

}


// WEBPACK FOOTER //
// ./src/Components/Leaderboard/LeaderboardPage.js